import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NO_INVOICE_DATA } from 'src/defaultImages';

@Component({
  selector: 'app-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.css'],
})
export class NoDataComponent implements OnInit {
  images = {
    NO_INVOICE_DATA,
  };
  translationText;
  subscription = new Subscription();

  constructor(public _translateService: TranslateService
  ){
    this._translateService.use(localStorage.getItem('language') || 'en_US');
  }
  
  ngOnInit(): void {
    this.subscription.add(
      this._translateService
        .get(['NO_DATA'])
        .subscribe((translation) => {
          this.translationText = translation.NO_DATA;
        })
    );
  }
}
